// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notifications{\n    scrollbar-width: none;\n}\n\n.notifications::-webkit-scrollbar{\n    width: 0;\n}", "",{"version":3,"sources":["webpack://./src/components/notifications/notifications.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,QAAQ;AACZ","sourcesContent":[".notifications{\n    scrollbar-width: none;\n}\n\n.notifications::-webkit-scrollbar{\n    width: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
